import React from "react";

const DisplayFields = ({ icon, children, isForm, center }) => {
    const formatText = (text) => {
        if (typeof text === "string") {
            // Replace newlines with <br /> for proper HTML rendering
            return text.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    {index !== text.split("\n").length - 1 && <br />}
                </React.Fragment>
            ));
        }
        return text;
    };
    return (
        <div className="w-full flex group mt-1 justify-center">
            <div className="mr-5 md:mr-10 text-lg text-gray-700 flex-shrink-0 flex justify-center w-5">
                <div
                    className={`self-start ${
                        !center && !isForm && "pt-2"
                    } h-12 ${
                        center &&
                        "flex items-center justify-center pt-0 bg-gray"
                    } ${isForm && !center && "pt-5"}`}
                >
                    {icon ? icon : ""}
                </div>
            </div>
            <div
                className={`flex-1 h-full  break-words overflow-wrap-normal text-left py-1  `}
            >
                {typeof children === "string" ? formatText(children) : children}
            </div>
        </div>
    );
};

export default DisplayFields;
